export const getMenuById = (state, id) => state?.menus?.byId[id] ?? {}
